import type { Middleware, MiddlewareAPI } from "@reduxjs/toolkit";
import { isRejectedWithValue } from "@reduxjs/toolkit";
import i18n from "i18next";

import { showErrorNotification } from "../../../components/NotificationAlerts";
import { formatValidationErrors, isLegacyValidationErrorFormat, isNewValidationErrorFormat } from "../../errorHandling";

const rtkQueryErrorLogger: Middleware = (_api: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
        // @ts-ignore
        const errorData = action.payload?.data;

        // Check if this is a validation error (new or old format)
        const errorText =
            isNewValidationErrorFormat(errorData) || isLegacyValidationErrorFormat(errorData)
                ? formatValidationErrors(errorData, (key: string) => i18n.t(key))
                : // @ts-ignore
                  action.payload?.error || errorData?.message || errorData?.error || "common.error";

        const notificationPayload = {
            text: errorText,
            data: errorData,
            autoCloseDisabled: true,
        };

        _api.dispatch(showErrorNotification(notificationPayload));
    }

    return next(action);
};

export default rtkQueryErrorLogger;
